module.exports = __webpack_public_path__ + "img/skytte.f575ea28.png";